import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BYPASS_INTERCEPTOR } from 'app/core/interceptor/auth-bypass.token';

@Injectable({
  providedIn: 'root'
})

export class S1PrivateService {
  params: any;
  constructor(private http: HttpClient) { }

  getparams(): Observable<any> {
    return this.http.get("private/server/params", { context: new HttpContext().set(BYPASS_INTERCEPTOR, true) });
  }

}